import React, { useContext } from "react";
import { bool, node, string } from "prop-types";
import TransactionStatus from "pages/transactions/_components/TransactionStatus";
import * as i18n from "util/i18n";
import { isIOS } from "react-device-detect";
import Image from "../Image";
import { TransactionContext } from "./TransactionContext";

export const TransactionHeader = ({
    title,
    subTitle,
    status,
    infoComponents,
    shorterStatusTitle,
    titleWithI18N,
    subTitleWithI18N,
}) => {
    const { transaction } = useContext(TransactionContext);

    const idTransactionStatus = status || transaction.idTransactionStatus;
    const _subTitle = subTitle || `ticket.status.${idTransactionStatus}`;
    const statusTitle = shorterStatusTitle
        ? `ticket.status.${idTransactionStatus}`
        : `forms.transaction.ticket.status.${idTransactionStatus}.firstTitle`;
    return (
        <>
            <div className="hidden show-print">
                <div className="voucher-header">
                    <Image src="images/logoCompany.svg" />
                    <div
                        className="bibank-data"
                        dangerouslySetInnerHTML={{ __html: i18n.get("report.bibank.header") }}
                    />
                </div>
            </div>
            <div className={isIOS ? "media-object media-object-ios column" : "media-object column"}>
                {title && (
                    <div className="text-center">
                        <h1 className="hidden show-print">
                            {titleWithI18N ? i18n.get(title) : title} {infoComponents}
                        </h1>
                        <h3>{subTitleWithI18N ? i18n.get(_subTitle) : _subTitle}</h3>
                    </div>
                )}

                {!title && (
                    <div className="media-object--text">
                        <h5>{i18n.get(statusTitle)}</h5>
                    </div>
                )}
                <figure>
                    <TransactionStatus
                        className="no-print"
                        iconFidelity="ticket"
                        idTransactionStatus={idTransactionStatus}
                    />
                </figure>
            </div>
        </>
    );
};

TransactionHeader.propTypes = {
    status: string,
    title: string,
    subTitle: string,
    infoComponents: node,
    shorterStatusTitle: bool,
    titleWithI18N: bool,
    subTitleWithI18N: bool,
};

TransactionHeader.defaultProps = {
    status: "",
    title: "",
    subTitle: "",
    infoComponents: null,
    shorterStatusTitle: false,
    titleWithI18N: true,
    subTitleWithI18N: true,
};

export default TransactionHeader;
